import {translations} from 'presentation/translations-new';

const {confirm, professional, specialty} = translations['pt-br'].privateFlow.bookingFlow.steps;

const TELEHEALTH_LABELS = [specialty, professional, confirm];

export {TELEHEALTH_LABELS};
